import { Device } from "src/sections/dashboard/software/useGitHubStats";

export type GlucObject = {
  id: string;
  label: string;
  value: number;
  date: number;
};

export type GlucRanges = "low" | "inRange" | "high";

export type State = {
  state: {
    personId: string;
    userId: string;
  };
};

export interface DateRange {
  startDate?: Date;
  endDate?: Date;
}

export interface DefinedRange {
  label: string;
  startDate: Date;
  endDate: Date;
}

export interface Profile {
  id: string;
  avatar: string;
  email: string;
  name: string;
  experience: string;
  created_at: string;
  phone?: string;
  pump?: string;
  cgm?: string;
  smartwatch?: string;
  loopapp?: string;
  insulin?: string;
  cloud?: string;
  distribution3Days?: { inRange: number; low: number; high: number };
}

export interface TimeValue {
  time: string;
  timeAsSeconds: number;
  value: number;
}

export interface ProfileSettings {
  dia: number;
  carbratio: TimeValue[];
  sens: TimeValue[];
  basal: TimeValue[];
  target_low: TimeValue[];
  target_high: TimeValue[];
  units: string;
  timezone: string;
  [key: string]: string | number | TimeValue[];
}

export interface ProfilesStore {
  [profileName: string]: ProfileSettings;
}

export interface ProfilesStoreInformation {
  _id: string;
  defaultProfile: string;
  date: number;
  created_at: string;
  startDate: string;
  store: ProfilesStore;
}

export const emptyProfilesStoreInformation: ProfilesStoreInformation = {
  _id: "",
  defaultProfile: "",
  date: 0,
  created_at: "",
  startDate: "",
  store: {},
};

export const emptyProfileSettings: ProfileSettings = {
  dia: 0,
  carbratio: [],
  sens: [],
  basal: [],
  target_low: [],
  target_high: [],
  units: "",
  timezone: "",
};

export interface Option {
  label: string;
  value: string;
}

export interface DeviceOption {
  label: string;
  value: Device;
}

export const categoryOptions: Option[] = [
  {
    label: "Artificial Pancreas",
    value: "artificialPancreas",
  },
  {
    label: "Glucose Monitoring",
    value: "cgm",
  },
  {
    label: "Food",
    value: "food",
  },
  {
    label: "Fitness",
    value: "fitness",
  },
  {
    label: "Stress",
    value: "stress",
  },
  {
    label: "Sleep",
    value: "sleep",
  },
];

export const statusOptions: Option[] = [
  {
    label: "Released",
    value: "published",
  },
  {
    label: "Under development",
    value: "draft",
  },
];

export const branchOptions: Option[] = [
  {
    label: "Main",
    value: "main",
  },
  {
    label: "Beta",
    value: "beta",
  },
  {
    label: "Dev",
    value: "dev",
  },
];

export const deviceOptions: DeviceOption[] = [
  {
    label: "Web",
    value: "web",
  },
  {
    label: "iOS",
    value: "ios",
  },
  {
    label: "Android",
    value: "android",
  },
  {
    label: "Web/Desktop",
    value: "web/desktop",
  },
];
